module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orders-product"
  }, [_c('div', {
    staticClass: "title-products font-size",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(_vm._s(_vm.orderState) + " - Nro de Orden " + _vm._s(_vm.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-around",
    style: (("border-bottom: 0.1rem solid " + (_vm.globalColors.primary) + ";"))
  }, [_c('div', [_c('p', {
    staticClass: "text-bold font-size"
  }, [_vm._v("Precio Total: "), _c('span', {
    staticClass: "text-regular"
  }, [_vm._v("PEN " + _vm._s(_vm.orderTotal))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-bold font-size"
  }, [_vm._v("Fecha de la Orden: "), _c('span', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-bold font-size"
  }, [_vm._v("Estado: "), _c('span', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm.orderPaymentStateName))])])])]), _vm._v(" "), _c('p', {
    staticClass: "text-bold font-size"
  }, [_vm._v("Direccion: "), _c('span', {
    staticClass: "text-regular"
  }, [_vm._v(_vm._s(_vm.orderWarehouseAddress))])]), _vm._v(" "), _c('transition-group', {
    staticClass: "relative",
    attrs: {
      "name": "fade-lateral",
      "tag": "div"
    }
  }, [(_vm.currentProductIsEmpty) ? _c('div', {
    key: 1,
    staticClass: "absolute w-100"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table-detail-product', {
    attrs: {
      "rows": _vm.rows,
      "order-state": _vm.orderStateCode
    },
    on: {
      "rating": _vm.rating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-mobile"
  }, [_c('table-detail-product-mobile', {
    attrs: {
      "rows": _vm.rows,
      "order-state": _vm.orderStateCode
    },
    on: {
      "rating": _vm.rating
    }
  })], 1)]) : _c('div', {
    key: 2,
    staticClass: "product-rating-container absolute w-100"
  }, [_c('section', {
    staticClass: "product-rating"
  }, [_c('img', {
    staticClass: "product-rating-img",
    attrs: {
      "src": _vm.currentProduct.productImage,
      "alt": "imagen del producto"
    }
  }), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "product-rating-name"
  }, [_vm._v(_vm._s(_vm.currentProduct.productName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentProduct.description))]), _vm._v(" "), _c('span', {
    staticClass: "product-rating-code"
  }, [_vm._v(_vm._s(_vm.currentProduct.productCode))])])]), _vm._v(" "), _c('section', [_c('FormOpinion', {
    attrs: {
      "id": _vm.currentProductId
    },
    on: {
      "cancel-rating": _vm.cancelRating
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-404784d2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/orders-products.vue
// module id = 1102
// module chunks = 8